<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
        <v-layout wrap>
            <v-flex xs12 class="pb-2">
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="teacher && teacher.employeeID"
                            >
                                <div
                                    class="display-1 pt-2 font-weight-bold mb-0 ml-0"
                                >
                                    {{ teacher.teacherH }}
                                </div>
                                <div class="ml-0 mt-4">
                                    <div class="pl-3">
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Teacher:
                                            </div>
                                            <div>
                                                {{ teacher.teacher }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Employee ID:
                                            </div>
                                            <div>
                                                {{ teacher.employeeID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Teacher Code:
                                            </div>
                                            <div>
                                                {{ teacher.teacherCode }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Type:
                                            </div>
                                            <div>
                                                {{ teacher.type }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Branch:
                                            </div>
                                            <div>
                                                {{ teacher.branch }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Grade:
                                            </div>
                                            <div>
                                                {{ teacher.class }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Section:
                                            </div>
                                            <div>
                                                {{ teacher.section }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Building:
                                            </div>
                                            <div>
                                                {{ teacher.building }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Alert Phone:
                                            </div>
                                            <div>
                                                {{ teacher.alertPhone | phone }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Alert Time:
                                            </div>
                                            <div>
                                                {{ teacher.alertTime }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Pin Number:
                                            </div>
                                            <div>
                                                {{ teacher.pinNumber }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Connection Mode:
                                            </div>
                                            <div>
                                                {{ teacher.connectionMode }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Allow Broadcast:
                                            </div>
                                            <div>
                                                {{
                                                    teacher.allowBroadcast
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Allow Charge CC:
                                            </div>
                                            <div>
                                                {{
                                                    teacher.allowChargeCC
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="teacher.rejectTips"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Reject Tips:
                                            </div>
                                            <div>
                                                {{
                                                    teacher.rejectTips
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="teacher.lastCallAt"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Last Call At:
                                            </div>
                                            <div>
                                                {{ teacher.lastCallAt | time }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Tip Balance:
                                            </div>
                                            <div>
                                                {{
                                                    teacher.tipBalance
                                                        | currency
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Teacher Name Recording:
                                            </div>
                                            <audio
                                                v-if="
                                                    teacher.teacherNameRecording
                                                "
                                                class="mb-2"
                                                controls
                                                style="height: 25px;"
                                                :src="
                                                    teacher.teacherNameRecording
                                                "
                                            ></audio>
                                        </v-layout>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <v-spacer></v-spacer>

                    <!-- <v-layout
                        align-end
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click="openSpecialNeedsStudentView"
                        >
                            Spatial Needs Program
                        </v-btn>
                    </v-layout> -->
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card
                    class="pa-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-tabs color="success" dark icons-and-text>
                        <v-tabs-slider color="#fff"></v-tabs-slider>

                        <v-tab href="#tips">
                            Tips ({{ getTipCount() }})
                            <v-icon>mdi-currency-usd</v-icon>
                        </v-tab>

                        <v-tab href="#tips-grouped">
                            Tips Grouped ({{ getGroupedTipCount() }})
                            <v-icon>mdi-currency-usd</v-icon>
                        </v-tab>

                        <v-tab href="#calls">
                            Call Logs ({{ getCallLogCount() }})
                            <v-icon>mdi-phone</v-icon>
                        </v-tab>
                        <v-tab href="#teacher-notifications">
                            Notifications ({{ getNotificationsCount() }})
                            <v-icon>mdi-bell</v-icon>
                        </v-tab>

                        <v-tab-item value="tips">
                            <dx-grid
                                name="tip-grid"
                                class="tip-grid"
                                :beforeSetupGrid="beforeSetupGrid"
                                :url="tipTransactionUrl"
                                :columns="tipTransactionColumns"
                                title="Tips"
                                :hideHeader="true"
                                ref="tipTransactionGrid"
                                :onCellPrepared="onCellPrepared"
                                :expandedOptions="{
                                    enabled: true,
                                    allowExpandingAll: true,
                                    template: 'tip-transaction-details',
                                }"
                            ></dx-grid>
                        </v-tab-item>

                        <v-tab-item value="tips-grouped">
                            <dx-grid
                                class="tip-grid"
                                name="tip-grid-grouped"
                                :beforeSetupGrid="beforeSetupGrid"
                                :url="tipUrl"
                                :columns="tipColumns"
                                title="Tips"
                                :hideHeader="true"
                                ref="tipGrid"
                                :expandedOptions="{
                                    enabled: true,
                                    allowExpandingAll: true,
                                    template: 'tip-details',
                                }"
                            ></dx-grid>
                        </v-tab-item>

                        <v-tab-item value="calls">
                            <dx-grid
                                class="tip-grid"
                                name="teacher-call-logs"
                                :beforeSetupGrid="beforeSetupGrid"
                                :url="callsUrl"
                                :columns="callsColumns"
                                title="Calls"
                                :hideHeader="true"
                                ref="callsGrid"
                                :expandedOptions="{
                                    enabled: true,
                                    allowExpandingAll: true,
                                    template: 'student-call-details',
                                }"
                            ></dx-grid>
                        </v-tab-item>

                        <v-tab-item value="teacher-notifications">
                            <v-progress-linear
                                v-if="loading"
                                :indeterminate="true"
                                color="success"
                            ></v-progress-linear>
                            <v-card
                                style=""
                                v-if="!loading"
                                class="pb-3 pt-1 px-2"
                                style="background-color:#f1ffdc"
                            >
                                <v-layout
                                    v-if="!teacherNotificationsToDisplay.length"
                                    justify-center
                                    align-center
                                    class="my-3 headline"
                                >
                                    No Notifications
                                </v-layout>
                                <div
                                    v-if="teacherNotificationsToDisplay.length"
                                >
                                    <v-card
                                        class="pb-4 pt-2 px-3 my-3"
                                        v-for="(teacherNotification,
                                        index) in teacherNotificationsToDisplay"
                                    >
                                        <v-layout row class="px-3 pb-1 pt-3">
                                            <div
                                                class="font-weight-medium mr-2 width-200"
                                            >
                                                Date:
                                            </div>
                                            <div>
                                                {{
                                                    teacherNotification.date
                                                        | time
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="px-3 py-1"
                                            v-if="
                                                teacherNotification.phoneNumber
                                            "
                                        >
                                            <div
                                                class="font-weight-medium mr-2 width-200"
                                            >
                                                Phone:
                                            </div>
                                            <div>
                                                {{
                                                    formatPhoneNumber(
                                                        teacherNotification.phoneNumber,
                                                    )
                                                }}
                                            </div>
                                        </v-layout>

                                        <v-btn
                                            class="mb-0"
                                            @click="
                                                openActions(teacherNotification)
                                            "
                                            color="success"
                                            outline
                                            small
                                            >{{
                                                teacherNotification.showActions
                                                    ? "Hide Actions"
                                                    : "Show Actions"
                                            }}</v-btn
                                        >

                                        <div
                                            class="mt-4"
                                            v-if="
                                                teacherNotification.showActions
                                            "
                                        >
                                            <div
                                                class="title"
                                                v-if="
                                                    !teacherNotification.actions
                                                        .length
                                                "
                                            >
                                                No Actions
                                            </div>
                                            <div
                                                class="dinner-ivr-detail-text px-3"
                                                v-for="(action,
                                                index) in teacherNotification.actions"
                                            >
                                                <div class="layout row ">
                                                    <div
                                                        class="mr-1  width-250"
                                                    >
                                                        {{ action.date }}
                                                    </div>
                                                    <div>
                                                        {{ action.title }}
                                                    </div>
                                                </div>
                                                <!-- <div class="layout row wrap mb-1 text--disabled">
                                                    <div>
                                                        {{ action.description }}
                                                    </div>
                                                </div> -->
                                                <div
                                                    class="layout row wrap mb-1 text--disabled"
                                                >
                                                    <div
                                                        v-if="
                                                            action.inputDigits
                                                        "
                                                    >
                                                        {{ action.inputDigits }}
                                                    </div>
                                                    <div
                                                        v-if="action.response"
                                                        class="px-1"
                                                    >
                                                        |
                                                    </div>
                                                    <div
                                                        v-if="
                                                            action.eventType !=
                                                                'START_PAYMENT_PROCESS'
                                                        "
                                                    >
                                                        {{ action.response }}
                                                    </div>
                                                </div>
                                                <v-divider
                                                    class="py-2 mb-1"
                                                    v-if="
                                                        index + 1 <
                                                            teacherNotification
                                                                .actions.length
                                                    "
                                                ></v-divider>
                                            </div>
                                        </div>
                                    </v-card>
                                </div>
                                <v-layout justify-center>
                                    <v-pagination
                                        v-model="pagination.page"
                                        :length="pages"
                                        :total-visible="7"
                                        v-on:input="setPagianation"
                                    ></v-pagination>
                                </v-layout>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { groupBy, formatPhoneNumber } from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        teacher: null,
        processing: false,
        loading: true,

        regID: "",

        tipUrl: "",
        tipTransactionUrl: "",
        callsUrl: "",

        pagination: {
            totalCount: 0,
            rowsPerPage: 5,
            page: 1,
        },

        teacherNotifications: [],
        teacherNotificationsToDisplay: [],

        tipTransactionColumns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "PROCESSED":
                            return "mdi-check-circle";
                        case "SCHEDULED":
                            return "mdi-clock";
                        case "VOIDED":
                        case "CANCELED":
                            return "mdi-cancel";
                        case "ERROR":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "PROCESSED":
                            return "success";
                        case "SCHEDULED":
                            return "#fdb400";
                        case "VOIDED":
                        case "CANCELED":
                            return "#aeb8bf";
                        case "ERROR":
                            return "#f35123";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Name",
                field: "studentName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Type",
                field: "teacherType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mailing Address",
                field: "mailingAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Read",
                field: "read",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notified",
                field: "notified",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        tipColumns: [
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Name",
                field: "studentName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Total Amount",
                field: "totalAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Amount",
                field: "paymentAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scheduled Amount",
                field: "scheduledAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        callsColumns: [
            {
                field: "phoneLine",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    switch (value) {
                        case "PARENTS LINE":
                            return "mdi-phone-incoming";
                        case "STUDENTS LINE":
                            return "mdi-phone-outgoing";
                        case "TEACHERS LINE":
                            return "mdi-account";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    switch (value) {
                        case "PARENTS LINE":
                            return "#007827";
                        case "STUDENTS LINE":
                            return "#27a4d9";
                        case "TEACHERS LINE":
                            return "#11b99a";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Employee ID",
                field: "employeeID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                //template: "utc-to-est-template",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Duration",
                field: "duration",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Minutes",
                field: "minutes",
                visible: false,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.teacherNotifications.length /
                          this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            await this.loadRegID();
            await this.loadTeacher();
            await this.loadTeacherNotifications();
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async loadTeacher() {
            const response = await this.$http.get(
                `odata/kesherEmployees?branch=&grade=&regID=${
                    this.regID
                }&$filter=employeeID eq ${this.$route.params.id}`,
            );

            this.teacher = response.value[0];

            if (response.value.length > 1) {
                this.teacher.type = response.value
                    .map((teacher) => {
                        return teacher.type;
                    })
                    .join(", ");
            }

            this.loading = false;
        },
        async loadTeacherNotifications() {
            const response = await this.$http.get(
                `api/teachers/getTeacherNotifications?employeeID=${
                    this.$route.params.id
                }`,
            );

            this.teacherNotifications = response.map((call) => {
                call.showActions = false;
                call.actions = [];

                return call;
            });

            this.teacherNotificationsToDisplay = response.slice(0, 5);
            this.pagination.totalCount = response.length;
            this.loading = false;
        },
        beforeSetupGrid() {
            this.tipTransactionUrl =
                "tipTransactions?fromDate=&employeeID=" + this.$route.params.id;

            this.tipUrl = "tips?employeeID=" + this.$route.params.id;

            this.callsUrl =
                "schoolCalls?branch=&employeeID=" + this.$route.params.id;
        },
        getTipCount() {
            if (
                this.$refs.tipTransactionGrid &&
                this.$refs.tipTransactionGrid.dataSource.totalCount
            ) {
                return this.$refs.tipTransactionGrid.dataSource.totalCount();
            }
            return 0;
        },
        getGroupedTipCount() {
            if (
                this.$refs.tipGrid &&
                this.$refs.tipGrid.dataSource.totalCount
            ) {
                return this.$refs.tipGrid.dataSource.totalCount();
            }
            return 0;
        },
        getCallLogCount() {
            if (
                this.$refs.callsGrid &&
                this.$refs.callsGrid.dataSource.totalCount
            ) {
                return this.$refs.callsGrid.dataSource.totalCount();
            }
            return 0;
        },
        getNotificationsCount() {
            if (!this.teacherNotifications.length) return 0;

            return this.teacherNotifications.length;
        },
        formatPhoneNumber(number) {
            return formatPhoneNumber(number);
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.teacherNotificationsToDisplay = this.teacherNotifications.slice(
                number,
                number + this.pagination.rowsPerPage,
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
        onCellPrepared(e) {
            // if (e.rowType === "data" && e.column.dataField === "amount") {
            //     e.cellElement.style.color = e.data.amount > 0 ? "green" : "red";
            //     e.watch(
            //         function() {
            //             return e.data.Amount;
            //         },
            //         function() {
            //             e.cellElement.style.color =
            //                 e.data.amount > 0 ? "green" : "red";
            //         }
            //     );
            // }
        },
        async openActions(call) {
            if (call.showActions) {
                call.showActions = false;
                return;
            }

            call.showActions = true;

            if (!call.actions.length) {
                const response = await this.$http.get(
                    "api/studentCalls/getDetails?callUUID=" + call.callUUID,
                );

                // call.actions = actions.map((action) => {
                //     action.date = moment(action.date).format("LTS");
                //     action.title =
                //         this.callActionsMap.get(action.eventType) ||
                //         action.eventType;
                //     action.description = this.getActionDescription(action);

                //     return action;
                // });

                call.actions = response.details.map((detail) => {
                    detail.date = moment(detail.date).format(
                        "MM/DD/YYYY h:mm:ss A",
                    );

                    detail.title = detail.eventType;

                    return detail;
                });
            }
        },
        getActionDescription(action) {
            if (
                [
                    "START_PAYMENT_PROCESS",
                    "START_AUTOPAYSETUP_PROCESS",
                ].includes(action.eventType)
            )
                return null;

            const inputActions = [
                "LOOKUP_PHONE",
                "VALIDATE_PHONE",
                "VALIDATE_PIN",
                "VALIDATE_CARD",
                "VALIDATE_EXP",
                "VALIDATE_SAVED_CARD",
            ];

            if (inputActions.includes(action.eventType)) {
                return action.inputDigits + " | " + action.response;
            }

            if (action.eventType == "CARD_PROCESSED_SUCCESS") {
                const pecies = action.response.split("|");
                const status = pecies
                    .find((p) => p.startsWith("status"))
                    .substring(7);
                const amount = pecies
                    .find((p) => p.startsWith("amount"))
                    .substring(7);

                return "$" + amount + " | " + status;
            }

            return action.response;
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.spacail-needs-link {
    color: rgb(76, 175, 80);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.tip-grid.container {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
}
.tip-grid .v-card__text {
    padding-top: 4px !important;
}
.tip-grid .flex {
    padding: 0px !important;
    padding-top: 24px !important;
}
.tip-grid .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
